import React,{useEffect} from 'react';
import HeaderSec from '../components/HeaderSec';
import Footer from '../components/Footer';
import PaymentMethods from '../components/PaymentMethods';
import CookiesPopup from '../components/CookiesPopup';
import WhatsappChat from '../components/WhatsappChat';
import ScrollTop from '../components/ScrollTop';
import ContactIcon from '../components/ContactIcon';
import RealisticGallery from '../components/RealisticGallery';
import CadModelingEditingGallery from '../components/CadModelingEditingGallery';
import GalleryVideos from '../components/GalleryVideos';
import Title from "../components/Title";
import GalleryBanner from '../components/gallery/GalleryBanner';
import ContactUs from '../components/ContactUs';

const Gallery = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
      }, []);
    return (
        <>
        <Title title="Gallery | CAD AND RENDER" />
        <HeaderSec />
        <ContactIcon />
        <WhatsappChat />
        <ScrollTop />
        <CookiesPopup />

        <GalleryBanner />

        <div className='cadGallerycontent cadAboutContent'>
            <div className='container'>
                <p>At CAD and RENDER, we specialize in providing high-quality jewelry 3D CAD Designing and Realistic Rendering services to jewelry manufacturers, wholesalers and retailers. With years of experience in the industry, we have become experts in our craft and are dedicated to providing exceptional service to our clients.</p>
            </div>
        </div>

        <div className='cadGalleyImagesMain cadAbout'>
            <div className='container'>
                <h2>IMAGE GALLERY</h2>

                <div className='cadGalleryRealistic'>
                    <h3>Realistic Images</h3>
                    <RealisticGallery />
                </div>

                <div className='cadGalleryCadModeling-CadEditing'>
                    <h3>CAD Modeling <span>&</span> CAD Editing</h3>
                    <CadModelingEditingGallery />
                </div>
                
            </div>
        </div>

        <div className='cadGalleyVideosMain cadAbout'>
            <div className='container'>
                <h2>VIDEO GALLERY</h2>
                <GalleryVideos />
            </div>
        </div>

        <ContactUs />

        <PaymentMethods />

        <Footer />
        </>
    );
}


export default Gallery;